module.exports =
  '_GROUP_MEMBERS':
    'EDIT_MEMBER': 'メンバーの編集'
    'REQUEST': 'リクエスト'
    'CLOSE': '閉じる'
    'SEARCH_MEMBER': 'メンバーを検索'
    'MEMBER': 'メンバー'
    'GROUP_ADMIN': '管理者'
    'DONE': '完了'
    'APPROVAL': '承認'
    'DELETE_REQUEST': 'リクエストを削除'
    'NO_NEW_REQUEST': '新しいリクエストはありません'
    'NUMBER_REQUEST': 'リクエスト{0}件'
    'ADMIN': '管理者'
    'DELETE_MEMBER': 'メンバーを削除'
    'FINISH': '完了'
    'TIME_AGO': '約{0}に参加しました。'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-member/i18n/ja.coffee